import { render, staticRenderFns } from "./model-r1-suggestions-to-improve-message-content-dialog.vue?vue&type=template&id=3bbee54c&scoped=true&"
import script from "./model-r1-suggestions-to-improve-message-content-dialog.vue?vue&type=script&lang=js&"
export * from "./model-r1-suggestions-to-improve-message-content-dialog.vue?vue&type=script&lang=js&"
import style0 from "./model-r1-suggestions-to-improve-message-content-dialog.vue?vue&type=style&index=0&id=3bbee54c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbee54c",
  null
  
)

export default component.exports